import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SubscriptionPaymentPanel from './SubscriptionPaymentPanel';
import { Lock } from 'lucide-react';
import { Button } from './ui/button';

export default function AdminSubscriptionBlocked() {
  const { user, logout, checkAuth } = useAuth();
  const sub = user?.subscription;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4 py-10">
      <div className="max-w-xl w-full text-center space-y-6">
        <Lock className="mx-auto text-rose-600" size={48} />
        <div>
          <h1 className="text-3xl font-semibold text-slate-900">Suscripción pendiente</h1>
          <p className="text-slate-600 text-sm mt-3">
            El periodo de tu suscripción ha vencido. Realiza el pago para recuperar el acceso al panel de
            administración.
          </p>
        </div>
        <div className="flex justify-center">
          <SubscriptionPaymentPanel subscription={sub} onUpdated={checkAuth} />
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button type="button" variant="outline" onClick={logout}>
            Cerrar sesión
          </Button>
          <Button asChild variant="outline">
            <Link to="/">Ir al sitio público</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
